export function longFormTextGenerator(title='', markdown='# Hello World!') {
  return {
    title,
    markdown
  };
}

export function videoEmbedGenerator(url) {
  return {
    url
  };
}

export function mapEmbedGenerator(lat=55.8681772, lng = -4.2783594) {
  return {
    center: { lat, lng }
  };
}

export function commentFormGenerator(postUrl='') {
  return {
    postUrl
  };
}

export function posterGenerator({image='', pdfLink=null, linkText=null, extraButtons=[], zoomPan=true, extraWide=false}) {
  return {
    image,
    pdfLink,
    linkText,
    zoomPan,
    extraWide,
    extraButtons,
  };
}

export function galleryGenerator({ images=[], markdownCaptions=[], modalStyle={} }) {
  return {
    images,
    markdownCaptions,
    modalStyle
  };
}

export function customFormGenerator({title, action, method="POST", partsConfig=[]}) {
  return {
    title, 
    action,
    method,
    partsConfig,
  };
}